import React from "react";
import { connect } from "react-redux";
import Button from "Components/button/Button";
import * as resActions from "../../modules/resources";
import { tzs, getPanelLangs } from "@/config";
import PropTypes from "prop-types";
import { alertSuccess } from "Utils/alerts";
import Input from "Components/input/Input";
import Select from "Components/select/Select";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import PasswordGenerator from "Components/PasswordGenerator";
import Toggle from "Components/toggle/Toggle";
import withFormState from "Components/withFormState";
import { formatServerErrors } from "Utils/serverFormats";
import QboxmailApi from "../../qboxmailApi";

import { t } from "i18next";
import cx from "classnames";

const propTypes = {};

const ContextTypes = {
  router: PropTypes.object,
  isLoggedUserTrial: PropTypes.func,
  getLoggedUser: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
};

const formInitialState = {
  timezone: "Europe/Rome",
  language: "it",
  max_email_accounts: -1,
  max_email_accounts_archive: -1,
  max_email_accounts_25gb: -1,
  max_email_accounts_50gb: -1,
  max_email_accounts_100gb: -1,
  max_domains: -1,
  catch_all: true,
};

class CustomerNewScreen extends React.Component {
  constructor(props) {
    super(props);
    this.fillPasswordFields = this.fillPasswordFields.bind(this);
    this.setValueAndToggleWholesale = this.setValueAndToggleWholesale.bind(this);
    this.setValueAndToggleReseller = this.setValueAndToggleReseller.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.state = {};
  }

  componentDidMount() {
    this.firstInput.focus();
  }

  validate(values) {
    const errors = {};
    const requiredFields = ["password", "password_confirmation", "firstname", "lastname"];
    for (let i = 0; i < requiredFields.length; i++) {
      if (!values[requiredFields[i]]) errors[requiredFields[i]] = "is required";
    }

    if (values.password.length < 8) errors.password = "is too short. Must be at least 8 chars";

    if (values.password_confirmation !== values.password_confirmation) {
      errors.password_confirmation = "is not the same";
    }
    return errors;
  }

  selectPlan = (val) => {
    // apply trial profile
    if (val.plan === "trial") {
      this.props.setFormFieldValue({
        max_domains: 5,
        max_email_accounts: 25,
        max_email_accounts_25gb: 0,
        max_email_accounts_50gb: 0,
        max_email_accounts_100gb: 0,
        max_email_accounts_archive: 0,
      });
    }

    this.props.setFormFieldValue(val);
  };

  submitForm = (e) => {
    const { refreshCustomers, unsetFormLoading, setFormLoading, formData, setFormErrors } = this.props;
    e.preventDefault();
    setFormLoading();
    const errors = this.validate(formData);
    if (Object.keys(errors).length > 0) {
      unsetFormLoading();
      setFormErrors(errors);
    } else {
      const client = new QboxmailApi({ useCookie: true });
      client
        .createCustomer(formData)
        .then((response) => {
          refreshCustomers();
          alertSuccess(t("alert.customer.created"));
          unsetFormLoading();
          this.resetAndGoBack();
        })
        .catch((response) => {
          formatServerErrors(response).then((errors) => {
            this.props.setFormErrors(errors);
            this.props.unsetFormLoading();
          });
        });
    }
  };

  resetAndGoBack() {
    this.props.resetForm();
    this.props.history.push("/customers");
  }

  setValueAndToggleWholesale(values) {
    this.props.setFormFieldValue({ is_wholesale: false, ...values });
  }

  setValueAndToggleReseller(values) {
    this.props.setFormFieldValue({ is_reseller: false, ...values });
  }

  fillPasswordFields(generatedPassword) {
    this.props.setFormFieldValue({
      password: generatedPassword,
      password_confirmation: generatedPassword,
    });
  }

  render() {
    const { setFormFieldValue, formData, formErrors, isFormLoading } = this.props;

    const plans = [
      { value: "trial", label: t("select.status.trial") },
      { value: "paid", label: t("select.status.paid") },
      { value: "free", label: t("select.status.free") },
    ];
    return (
      <div className="formsPage">
        <div className={cx("sectionTitle", "titleFP")}>{t("customer.add.title")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP" />
          <form className="wrapFormsFP" method="post" onSubmit={this.submitForm}>
            <div className="formsFP">
              <Input
                className="inputFull2"
                label={t("input.label.firstName")}
                placeholder={t("input.placeholder.firstName")}
                name="firstname"
                ref={(el) => (this.firstInput = el)}
                value={formData.firstname}
                onChange={setFormFieldValue}
                errors={formErrors.firstname}
                required
              />

              <Input
                className="inputFull2"
                label={t("input.label.lastName")}
                placeholder={t("input.placeholder.lastName")}
                name="lastname"
                value={formData.lastname}
                onChange={setFormFieldValue}
                errors={formErrors.lastname}
                required
              />

              <Input
                className={cx("inputFull2", "inputAddMargin")}
                label={t("input.label.email")}
                placeholder={t("input.placeholder.email")}
                name="email_address"
                value={formData.email_address}
                onChange={setFormFieldValue}
                errors={formErrors.email_address}
                required
              />

              <Select
                className={"inputAddMargin"}
                label={t("input.label.language")}
                components={{ DropdownIndicator }}
                name="language"
                options={getPanelLangs()}
                onChange={setFormFieldValue}
                value={formData.language}
                clearable={false}
              />

              <Select
                className={"inputAddMargin"}
                label={t("input.label.timezone")}
                components={{ DropdownIndicator }}
                name="timezone"
                options={tzs}
                onChange={setFormFieldValue}
                value={formData.timezone}
                required
              />

              <Input
                className="inputFull2"
                label={t("input.label.password")}
                name="password"
                type="password"
                value={formData.password}
                onChange={setFormFieldValue}
                errors={formErrors.password}
                required
              />

              <Input
                className="inputFull2"
                label={t("input.label.passwordConfirm")}
                name="password_confirmation"
                type="password"
                value={formData.password_confirmation}
                onChange={setFormFieldValue}
                errors={formErrors.password_confirmation}
                required
              />

              <PasswordGenerator
                className={cx("inputFull2", "inputAddMargin")}
                onNewPassword={this.fillPasswordFields}
              />

              <Toggle
                className="inputFull2"
                label={t("input.label.can.haveCatchAll")}
                checked={formData.catch_all}
                onChange={setFormFieldValue}
                name="catch_all"
              />

              <Toggle
                className="inputFull2"
                label={t("input.label.is.reseller")}
                checked={formData.is_reseller}
                onChange={this.setValueAndToggleWholesale}
                name="is_reseller"
                disabled={formData.is_wholesale}
              />

              <Toggle
                className={cx("inputFull2", "inputAddMargin")}
                label={t("input.label.is.wholesale")}
                checked={formData.is_wholesale}
                onChange={this.setValueAndToggleReseller}
                name="is_wholesale"
                disabled={formData.is_reseller}
              />

              <Select
                className={"inputFull2"}
                label={t("input.label.select.plan")}
                components={{ DropdownIndicator }}
                name="plan"
                options={plans}
                onChange={this.selectPlan}
                value={formData.plan}
                clearable={false}
              />

              <Input
                label={t("input.label.maxDomainsAvailable")}
                name="max_domains"
                onChange={setFormFieldValue}
                value={formData.max_domains}
                errors={formErrors.max_domains}
                disabled={formData.plan === "trial"}
                type="number"
                min={-1}
                max={this.state.maxEmailAccountsSelected}
                step={1}
                required
              />

              <Input
                label={t("input.label.maxAccountsAvailable8")}
                name="max_email_accounts"
                onChange={setFormFieldValue}
                value={formData.max_email_accounts}
                errors={formErrors.max_email_accounts}
                type="number"
                min={-1}
                max={this.state.maxEmailAccountsSelected}
                step={1}
                required
                disabled={formData.plan === "trial"}
              />

              <Input
                className="inputAddMargin"
                label={t("input.label.maxAccountsAvailable25")}
                name="max_email_accounts_25gb"
                type="number"
                onChange={setFormFieldValue}
                value={formData.max_email_accounts_25gb}
                errors={formErrors.max_email_accounts_25gb}
                min={-1}
                max={this.state.maxEmailAccountsSelected}
                step={1}
                required
                disabled={formData.plan === "trial"}
              />

              <Input
                className="inputAddMargin"
                label={t("input.label.maxAccountsAvailable50")}
                name="max_email_accounts_50gb"
                type="number"
                onChange={setFormFieldValue}
                value={formData.max_email_accounts_50gb}
                errors={formErrors.max_email_accounts_50gb}
                min={-1}
                max={this.state.maxEmailAccountsSelected}
                step={1}
                disabled={formData.plan === "trial"}
                required
              />

              <Input
                className="inputAddMargin"
                label={t("input.label.maxAccountsAvailable100")}
                name="max_email_accounts_100gb"
                type="number"
                onChange={setFormFieldValue}
                value={formData.max_email_accounts_100gb}
                errors={formErrors.max_email_accounts_100gb}
                min={-1}
                max={this.state.maxEmailAccountsSelected}
                step={1}
                disabled={formData.plan === "trial"}
                required
              />

              <Input
                className="inputAddMargin"
                label={t("input.label.maxArchiveAvailable")}
                name="max_email_accounts_archive"
                type="number"
                onChange={setFormFieldValue}
                value={formData.max_email_accounts_archive}
                errors={formErrors.max_email_accounts_archive}
                min={-1}
                max={this.state.maxEmailAccountsSelected}
                step={1}
                disabled={formData.plan === "trial"}
                required
              />
            </div>
            <div className="footerFP">
              <Button color="text" onClick={() => this.props.history.push("/customers")}>
                button.cancel
              </Button>
              <Button color="green" type="submit" loading={isFormLoading}>
                button.create
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

//CustomerNewScreen.propTypes = propTypes;
CustomerNewScreen.contextTypes = ContextTypes;

const mapStateToProps = (state) => ({
  customerProfiles: resActions.getData("customerProfiles.data", state),
});

const mapDispatchToProps = (dispatch) => ({
  getCustomerProfiles: () => dispatch(resActions.callApi("getCustomerProfiles", "customerProfiles")),
  refreshCustomers: (queryParams) => dispatch(resActions.callApi("refreshCustomers", "customers", queryParams)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withFormState(CustomerNewScreen, formInitialState));
